var _mask, _path, _g, _path2, _path3, _g2, _path4, _mask2, _path5, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportSinceActive = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 501 501",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1434_2584",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.811 357.362C287.612 364.163 287.662 375.268 280.206 381.342C257.848 399.558 231.167 411.89 202.605 417.063C168.31 423.273 132.937 418.864 101.215 404.427C69.4941 389.99 42.9367 366.212 25.0948 336.272C7.25293 306.333 -1.02294 271.66 1.37395 236.891C3.77084 202.121 16.7262 168.912 38.5076 141.704C60.289 114.496 89.858 94.5872 123.26 84.6392C156.663 74.6912 192.306 75.1785 225.424 86.0358C253.007 95.0785 277.743 110.956 297.39 132.067C303.942 139.107 302.368 150.1 294.699 155.903L188.052 236.597C179.626 242.974 178.774 255.325 186.246 262.797L280.811 357.362Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.811 357.362C287.612 364.163 287.662 375.268 280.206 381.342C257.848 399.558 231.167 411.89 202.605 417.063C168.31 423.273 132.937 418.864 101.215 404.427C69.4941 389.99 42.9367 366.212 25.0948 336.272C7.25293 306.333 -1.02294 271.66 1.37395 236.891C3.77084 202.121 16.7262 168.912 38.5076 141.704C60.289 114.496 89.858 94.5872 123.26 84.6392C156.663 74.6912 192.306 75.1785 225.424 86.0358C253.007 95.0785 277.743 110.956 297.39 132.067C303.942 139.107 302.368 150.1 294.699 155.903L188.052 236.597C179.626 242.974 178.774 255.325 186.246 262.797L280.811 357.362Z",
    fill: "#C59331",
    stroke: "black",
    strokeWidth: 34.0175,
    mask: "url(#path-1-inside-1_1434_2584)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1434_2584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.732 28.2032C180.732 23.5318 184.519 19.7448 189.191 19.7448L392.961 19.7422C395.172 19.7422 397.295 20.6079 398.875 22.154L477.004 98.5767C478.631 100.168 479.548 102.348 479.548 104.623V472.83C479.548 477.502 475.761 481.289 471.09 481.289H189.191C184.519 481.289 180.732 477.502 180.732 472.83V28.2032Z",
    fill: "#F9F4EA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392.96 11.2379L189.191 11.2404C179.822 11.2405 172.228 18.8349 172.228 28.2032V472.83C172.228 482.199 179.823 489.793 189.191 489.793H471.09C480.458 489.793 488.053 482.199 488.053 472.83V104.623C488.053 100.06 486.214 95.6884 482.951 92.4972L404.822 16.0745C401.652 12.9739 397.395 11.2378 392.96 11.2379Z",
    stroke: "black",
    strokeWidth: 17.0087,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M396.695 100.618V12.2767C396.695 11.5501 397.578 11.191 398.085 11.7114L484.18 100.052C484.68 100.566 484.316 101.428 483.6 101.428H397.505C397.058 101.428 396.695 101.065 396.695 100.618Z",
    fill: "#060F1F",
    stroke: "black",
    strokeWidth: 15.7938
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1434_2584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.945 216.122V51.4623C209.945 51.015 210.312 50.6521 210.759 50.6544C299.097 51.0925 371.84 122.691 372.261 216.117C372.263 216.564 371.9 216.932 371.453 216.932H210.755C210.308 216.932 209.945 216.569 209.945 216.122Z",
    fill: "#060F1F"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M209.945 216.122V51.4623C209.945 51.015 210.312 50.6521 210.759 50.6544C299.097 51.0925 371.84 122.691 372.261 216.117C372.263 216.564 371.9 216.932 371.453 216.932H210.755C210.308 216.932 209.945 216.569 209.945 216.122Z",
    stroke: "black",
    strokeWidth: 15.3889
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_1434_2584",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.251 248.66C343.251 284.096 332.251 318.658 311.77 347.576C291.289 376.493 262.337 398.34 228.91 410.101C195.482 421.862 159.229 422.956 125.153 413.234C91.0772 403.511 60.8596 383.45 38.6714 355.821L172.11 248.66H343.251Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M343.251 248.66C343.251 284.096 332.251 318.658 311.77 347.576C291.289 376.493 262.337 398.34 228.91 410.101C195.482 421.862 159.229 422.956 125.153 413.234C91.0772 403.511 60.8596 383.45 38.6714 355.821L172.11 248.66H343.251Z",
    fill: "#060F1F",
    stroke: "black",
    strokeWidth: 34.0175,
    mask: "url(#path-6-inside-2_1434_2584)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 365.045,
    y: 19.7422,
    width: 23.6241,
    height: 21.3085,
    fill: "#F9F4EA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1434_2584",
    x: 163.725,
    y: 2.73438,
    width: 332.832,
    height: 495.562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -43.3318,
    dy: 2.02485
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.576471 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1434_2584"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1434_2584",
    x: 202.25,
    y: 42.9609,
    width: 177.705,
    height: 181.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -31.1827,
    dy: 10.5292
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1434_2584"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportSinceActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reportSinceActive.8a2659b832b46da60e7fabf6b64934fa.svg";